import React from "react";

export default function AppWrapper({ children }) {
  const [loaded, setLoaded] = React.useState(false);

  React.useEffect(() => {
    const timer = setTimeout(() => setLoaded(true), 50);
    return () => clearTimeout(timer);
  }, []);

  React.useEffect(() => {
    if (loaded) {
      const cover = document.getElementById("loadingCover");
      if (cover) {
        cover.classList.add("hidden");
        setTimeout(() => cover.remove(), 300);
      }
    }
  }, [loaded]);

  return <>{children}</>;
}
